const upsellBundleSelectors = document.querySelector("div.upsell_enabled");

document.addEventListener("DOMContentLoaded", () => {
    const bundleSelectors = document.querySelectorAll(
        '[data-element-type="bundle-selector"]'
    );
    const addToCartFormInput = document.querySelector(
        'form[data-type="add-to-cart-form"] input[name="id"]'
    );

    const payFullPriceElements = document.querySelectorAll(
        '[data-element-type="pay-full-price"]'
    );
    const payPartPriceElements = document.querySelectorAll(
        '[data-element-type="pay-part-price"]'
    );
    const checkoutButton = document.querySelector("#checkout-button");

    const updatePrices = (bundle) => {
        const selectedPayPartPriceValue = bundle.querySelector(
            'input[name="payPartPrice"]'
        ).getAttribute('data-half-price');
        const selectedPayFullPriceValue = bundle.querySelector(
            'input[name="payFullPrice"]'
        ).getAttribute('data-full-price');

        payPartPriceElements.forEach((payPartPriceElement) => {
            payPartPriceElement.textContent = selectedPayPartPriceValue;
        });

        payFullPriceElements.forEach((payFullPriceElement) => {
            payFullPriceElement.textContent = selectedPayFullPriceValue;
        });
    };

    bundleSelectors.forEach((bundle, index, array) => {
        const bundleInput = bundle.querySelector('input[type="radio"]');
        const inputRadio = bundle.querySelector(
            '[data-element-type="radio-button"]'
        );
        const selectedArrow = bundle.querySelector(
            '[data-element-type="selected-arrow"]'
        );

        const updateFormInput = () => {
            if (bundleInput.checked) {
                const variantId = bundleInput.getAttribute("value");
                if (addToCartFormInput) {
                    const formType = addToCartFormInput.getAttribute('form-type');
                    if (formType !== 'cart-upsell') {
                        addToCartFormInput.setAttribute("value", variantId);
                    }
                }
                if (checkoutButton) {
                    checkoutButton.href = `/cart/${variantId}:1`;
                }
            }
        };

        bundleInput.addEventListener("click", () => {
            updateFormInput();

            const allInputRadios = document.querySelectorAll(
                '[data-element-type="radio-button"]'
            );

            const allSelectedArrows = document.querySelectorAll(
                '[data-element-type="selected-arrow"]'
            );

            allInputRadios.forEach((radio) => {
                radio.classList.add("hidden");
            });

            inputRadio.classList.remove("hidden");

            if (allSelectedArrows) {
                allSelectedArrows.forEach((arrow) => {
                    arrow.classList.add("hidden");
                });

                if (selectedArrow) {
                    selectedArrow.classList.remove("hidden");
                }
            }

            updatePrices(bundle);
        });

        updateFormInput();

        if (bundleInput.checked) {
            inputRadio.classList.remove("hidden");
            updatePrices(bundle); // Update prices on page load based on the checked bundle
            if (selectedArrow) {
                selectedArrow.classList.remove("hidden");
            }
        } else {
            inputRadio.classList.add("hidden");
            if (selectedArrow) {
                selectedArrow.classList.remove("hidden");
            }
        }

        // If this is the first bundle, automatically check its radio button
        // if (index === 0) {
        //   bundleInput.checked = true;
        //   bundleInput.dispatchEvent(new Event("click"));
        // }
    });

    for (const bundleSelector of bundleSelectors) {
        bundleSelector.onclick = function (event) {
            const itemCount = bundleSelector.getAttribute('data-item-count');

            for (const oneElement of bundleSelectors) {
                oneElement.classList.remove('active');
            }
            bundleSelector.classList.add('active');

            const customTitle = bundleSelector.getAttribute('data-variant-title');
            if (customTitle) {
                const customTitleElement = document.querySelector('.product-section-dynamic-title');
                if (customTitleElement) {
                    customTitleElement.textContent = customTitle;
                }
            }

            // Update variant image dynamatically
            if (itemCount) {
                const imageToReplace = document.querySelector(`.hidden-variant-advert-image[data-count="${itemCount}"]`);
                const parentElement = document.querySelector('#my-keen-slider .keen-slider__slide:first-child > div');

                if (imageToReplace && parentElement) {
                    parentElement.innerHTML = '';
                    parentElement.appendChild(imageToReplace.cloneNode(true));
                }
            }
        };
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const mainBtn = document.querySelector('button.add-to-cart--main');
    const upsellBtn = document.querySelector('button.add-to-cart--upsell');
    const upsellBlock = document.querySelector('.product-bundle-suscription-upsell');

    if (!mainBtn) return;

    mainBtn.addEventListener('click', () => {
        // Only fire if upsell block is active
        if (upsellBlock && upsellBlock.classList.contains('active')) {
            setTimeout(() => {
                if (upsellBtn) upsellBtn.click();
            }, 100);
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-bundle-suscription-upsell')
        .forEach(el => {
            el.addEventListener('click', () => {
                el.classList.toggle('active');
            });
        });
});
